var exports = {
  "K": "BadgeIcon.module__icon___a0VjOE",
};

module.exports = exports;
